import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import EnableColorOnDarkAppBar from './EnableColorOnDarkAppBar';
import ClientProvider from './client';
export default createDemo(import.meta.url, EnableColorOnDarkAppBar, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/app-bar/demos/enable-color-on-dark/EnableColorOnDarkAppBar.tsx",
    "fileName": "EnableColorOnDarkAppBar.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import AppBar from '@mui/material/AppBar';\nimport Stack from '@mui/material/Stack';\nimport Toolbar from '@mui/material/Toolbar';\nimport Typography from '@mui/material/Typography';\nimport IconButton from '@mui/material/IconButton';\nimport MenuIcon from '@mui/icons-material/Menu';\nimport { ThemeProvider, createTheme } from '@mui/material/styles';\n\nfunction appBarLabel(label: string) {\n  return (\n    <Toolbar>\n      <IconButton edge=\"start\" color=\"inherit\" aria-label=\"menu\" sx={{ mr: 2 }}>\n        <MenuIcon />\n      </IconButton>\n      <Typography variant=\"h6\" noWrap component=\"div\" sx={{ flexGrow: 1 }}>\n        {label}\n      </Typography>\n    </Toolbar>\n  );\n}\n\nconst darkTheme = createTheme({\n  palette: {\n    mode: 'dark',\n    primary: {\n      main: '#1976d2',\n    },\n  },\n});\n\nexport default function EnableColorOnDarkAppBar() {\n  return (\n    <Stack spacing={2} sx={{ flexGrow: 1 }}>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 3,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <ThemeProvider theme={darkTheme}>\n        <AppBar position=\"static\" color=\"primary\" enableColorOnDark>\n          {appBarLabel('enableColorOnDark')}\n        </AppBar>\n        <AppBar position=\"static\" color=\"primary\">\n          {appBarLabel('default')}\n        </AppBar>\n      </ThemeProvider>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </Stack>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 44,
        "focusedLines": 8,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import AppBar from '@mui/material/AppBar';\nimport Stack from '@mui/material/Stack';\nimport Toolbar from '@mui/material/Toolbar';\nimport Typography from '@mui/material/Typography';\nimport IconButton from '@mui/material/IconButton';\nimport MenuIcon from '@mui/icons-material/Menu';\nimport { ThemeProvider, createTheme } from '@mui/material/styles';\n\nfunction appBarLabel(label: string) {\n  return (\n    <Toolbar>\n      <IconButton edge=\"start\" color=\"inherit\" aria-label=\"menu\" sx={{ mr: 2 }}>\n        <MenuIcon />\n      </IconButton>\n      <Typography variant=\"h6\" noWrap component=\"div\" sx={{ flexGrow: 1 }}>\n        {label}\n      </Typography>\n    </Toolbar>\n  );\n}\n\nconst darkTheme = createTheme({\n  palette: {\n    mode: 'dark',\n    primary: {\n      main: '#1976d2',\n    },\n  },\n});\n\nexport default function EnableColorOnDarkAppBar() {\n  return (\n    <Stack spacing={2} sx={{ flexGrow: 1 }}>\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        "      <ThemeProvider theme={darkTheme}>\n        <AppBar position=\"static\" color=\"primary\" enableColorOnDark>\n          {appBarLabel('enableColorOnDark')}\n        </AppBar>\n        <AppBar position=\"static\" color=\"primary\">\n          {appBarLabel('default')}\n        </AppBar>\n      </ThemeProvider>\n"
      ],
      [
        "span",
        "frame",
        "    </Stack>\n  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 34
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "ThemeProvider"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "theme"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi di-jv",
                "darkTheme"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 35
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "AppBar"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "position"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "static",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "color"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "primary",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "enableColorOnDark"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 36
            },
            [
              "          ",
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-en",
                "appBarLabel"
              ],
              "(",
              [
                "span",
                "pl-s",
                [
                  [
                    "span",
                    "pl-pds",
                    "'"
                  ],
                  "enableColorOnDark",
                  [
                    "span",
                    "pl-pds",
                    "'"
                  ]
                ]
              ],
              ")",
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 37
            },
            [
              "        </",
              [
                "span",
                "pl-c1 di-jsx",
                "AppBar"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 38
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "AppBar"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "position"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "static",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "color"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "primary",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 39
            },
            [
              "          ",
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-en",
                "appBarLabel"
              ],
              "(",
              [
                "span",
                "pl-s",
                [
                  [
                    "span",
                    "pl-pds",
                    "'"
                  ],
                  "default",
                  [
                    "span",
                    "pl-pds",
                    "'"
                  ]
                ]
              ],
              ")",
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 40
            },
            [
              "        </",
              [
                "span",
                "pl-c1 di-jsx",
                "AppBar"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 41
            },
            [
              "      </",
              [
                "span",
                "pl-c1 di-jsx",
                "ThemeProvider"
              ],
              ">"
            ]
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 44,
    "focusedLines": 8,
    "collapsible": true,
    "externals": [
      "@mui/material/AppBar",
      "@mui/material/Stack",
      "@mui/material/Toolbar",
      "@mui/material/Typography",
      "@mui/material/IconButton",
      "@mui/icons-material/Menu",
      "@mui/material/styles"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
